<template>
  <div class="crm-actions">
    <p class="grey--text mt-4">Кожна зміна в адмінці та кожне вивантаження даних: хто, коли, що і з якої IP-адреси.</p>
    <v-data-table
      :headers="headers"
      :items="rows"
      :loading="loading"
      :server-items-length="total"
      :options.sync="options"
      :footer-props="{ itemsPerPageOptions: [50], itemsPerPageText: 'Рядків на сторінці' }"
      loading-text="Завантаження…"
      no-data-text="Записів ще немає"
      class="crm__table"
    >
      <template v-slot:[`item.created_at`]="{ item }">{{ human(item.created_at) }}</template>
      <template v-slot:[`item.action`]="{ item }">
        <div>{{ item.method }} {{ item.path }}</div>
        <div class="caption grey--text">{{ item.action }}</div>
      </template>
      <template v-slot:[`item.details`]="{ item }">
        <div class="crm-actions__details">{{ details(item.details) }}</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiClient from "@/libs/http-client";

export default {
  name: "CrmActions",
  data() {
    return {
      rows: [],
      total: 0,
      loading: false,
      options: { page: 1, itemsPerPage: 50 },
      headers: [
        { text: "Коли", value: "created_at", sortable: false },
        { text: "Хто", value: "admin", sortable: false },
        { text: "Дія", value: "action", sortable: false },
        { text: "Дані", value: "details", sortable: false },
        { text: "IP", value: "ip", sortable: false },
        { text: "Код", value: "status", sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  methods: {
    load() {
      this.loading = true;
      ApiClient.get("api/admin/crm/actions", { params: { page: this.options.page } })
        .then((response) => {
          if (!response) return;
          this.rows = response.data.data;
          this.total = response.data.meta.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    human(value) {
      return value ? new Date(value).toLocaleString("uk-UA") : "";
    },
    details(value) {
      if (!value) return "";
      const text = JSON.stringify(value);
      return text.length > 300 ? text.slice(0, 300) + "…" : text;
    },
  },
};
</script>

<style lang="scss" scoped>
.crm-actions__details {
  max-width: 420px;
  font-family: monospace;
  font-size: 12px;
  word-break: break-all;
}
</style>
